<app-login class="push-xxl"></app-login>

<div class="app-version-info">
  <span i18n>Version</span>: {{version}}
</div>